import Rules from "./Rules";
import ThreeDoorSolver from "./ThreeDoorSolver";
import Navigation from "./Navigation";

const PageAuto = () => {
  return (
    <div className="bg-blue w-full min-w-full min-h-screen font-primary">
      <div className="container">
        <Navigation />
        <main className="w-full">
          <div className="flex flex-col text-black">  
            <Rules />        
            <div className="my-8 border"></div>
            <ThreeDoorSolver />
          </div>
        </main>
      </div>
    </div>
  );
}
export default PageAuto;